var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    sample: true,
    playing: _vm.playingClass,
    queuedIn: _vm.queuedInClass,
    queuedOut: _vm.queuedOutClass
  },attrs:{"name":_vm.source.name},on:{"click":_vm.emitClick}})}
var staticRenderFns = []

export { render, staticRenderFns }